'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

interface TabItem {
  label: string;
  path: string;
  icon: string;
  badge?: number | null;
}

interface BottomTabNavigationProps {
  className?: string;
}

const BottomTabNavigation = ({ className = '' }: BottomTabNavigationProps) => {
  const pathname = usePathname();

  const tabs: TabItem[] = [
    {
      label: 'Home',
      path: '/home-dashboard',
      icon: 'HomeIcon',
      badge: null
    },
    {
      label: 'Projects',
      path: '/projects-list',
      icon: 'FolderIcon',
      badge: null
    },
    {
      label: 'Settings',
      path: '/settings',
      icon: 'CogIcon',
      badge: null
    }
  ];

  const isActiveTab = (tabPath: string) => {
    if (tabPath === '/home-dashboard') {
      return pathname === '/home-dashboard' || pathname === '/';
    }
    if (tabPath === '/projects-list') {
      return pathname === '/projects-list' || pathname === '/project-detail' || pathname === '/add-project';
    }
    return pathname === tabPath;
  };

  return (
    <nav data-component-id="src/components/common/BottomTabNavigation.tsx:54:4" data-component-path="src/components/common/BottomTabNavigation.tsx" data-component-line="54" data-component-end-line="100" data-component-file="BottomTabNavigation.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D" 
      className={`fixed bottom-0 left-0 right-0 bg-card border-t border-border z-100 ${className}`}
      role="tablist"
      aria-label="Main navigation"
    >
      <div data-component-id="src/components/common/BottomTabNavigation.tsx:59:6" data-component-path="src/components/common/BottomTabNavigation.tsx" data-component-line="59" data-component-end-line="99" data-component-file="BottomTabNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-around%20h-15%20px-4%20max-w-md%20mx-auto%22%7D" className="flex items-center justify-around h-15 px-4 max-w-md mx-auto">
        {tabs.map((tab) => {
          const isActive = isActiveTab(tab.path);
          
          return (
            <Link data-component-id="src/components/common/BottomTabNavigation.tsx:64:12" data-component-path="src/components/common/BottomTabNavigation.tsx" data-component-line="64" data-component-end-line="96" data-component-file="BottomTabNavigation.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
              key={tab.path}
              href={tab.path}
              role="tab"
              aria-selected={isActive}
              aria-label={`Navigate to ${tab.label}`}
              className={`
                flex flex-col items-center justify-center min-w-0 flex-1 py-2 px-1 
                transition-smooth hover:bg-muted/50 rounded-lg relative
                ${isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'}
              `}
            >
              <div data-component-id="src/components/common/BottomTabNavigation.tsx:76:14" data-component-path="src/components/common/BottomTabNavigation.tsx" data-component-line="76" data-component-end-line="92" data-component-file="BottomTabNavigation.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
                <Icon data-component-id="src/components/common/BottomTabNavigation.tsx:77:16" data-component-path="src/components/common/BottomTabNavigation.tsx" data-component-line="77" data-component-end-line="82" data-component-file="BottomTabNavigation.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22mb-1%22%7D" 
                  name={tab.icon as any}
                  size={24}
                  variant={isActive ? 'solid' : 'outline'}
                  className="mb-1"
                />
                {tab.badge && tab.badge > 0 && (
                  <span data-component-id="src/components/common/BottomTabNavigation.tsx:84:18" data-component-path="src/components/common/BottomTabNavigation.tsx" data-component-line="84" data-component-end-line="90" data-component-file="BottomTabNavigation.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20-top-2%20-right-2%20bg-accent%20text-accent-foreground%20text-xs%20%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20rounded-full%20min-w-5%20h-5%20flex%20items-center%20justify-center%20px-1%22%7D" 
                    className="absolute -top-2 -right-2 bg-accent text-accent-foreground text-xs 
                             rounded-full min-w-5 h-5 flex items-center justify-center px-1"
                    aria-label={`${tab.badge} notifications`}
                  >
                    {tab.badge > 99 ? '99+' : tab.badge}
                  </span>
                )}
              </div>
              <span data-component-id="src/components/common/BottomTabNavigation.tsx:93:14" data-component-path="src/components/common/BottomTabNavigation.tsx" data-component-line="93" data-component-end-line="95" data-component-file="BottomTabNavigation.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xs%20font-medium%20truncate%20max-w-full%22%7D" className="text-xs font-medium truncate max-w-full">
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabNavigation;